import React from 'react';
import NotificationManager from 'dom-managers/notification';

const availableFileExtensions = /\.(pdf|png|doc|docx|xls|xlsx|jpg|jpeg|txt|msg)$/;
const maxSize = 26214400;
const forbidenSumbols = /\/|\\|\?|%|\*|:|\||"|<|>|#/;

export default function UploadButton({
  error,
  errorClassName,
  handleFileSelect,
  editableStateSectionHeader,
  sectionHeaderClassName,
  uploadButtonText,
  files,
}) {
  const _handleFileChoose = event => {
    const files = event.target.files;
    files.filter = Array.prototype.filter;

    let approvedFiles = event.target.files.filter(file => {
      return !forbidenSumbols.test(file.name.toLowerCase());
    });
    if (files.length !== approvedFiles.length) {
      NotificationManager.error(
        'note',
        'File name contains prohibited characters. The following characters are not allowed: / \\ ? % * : | " < > #'
      );
    } else {
      approvedFiles = approvedFiles.filter(file => {
        return availableFileExtensions.test(file.name.toLowerCase()) && file.size <= maxSize;
      });
      if (files.length !== approvedFiles.length) {
        NotificationManager.error('note', 'One of files was of wrong format or too big');
      } else {
        handleFileSelect(approvedFiles);
      }
    }

    event.target.value = '';
  };

  return (
    <React.Fragment>
      <div className={`ect-file-picker__button-wrapper ${files.length ? '_margin_bottom_30' : ''}`}>
        {error && <div className={`ect-file-picker__error-message ${errorClassName}`}>{error}</div>}
        <label htmlFor='fileButton' className='ect-file-picker__button _height_34 _width_145'>
          {uploadButtonText}
        </label>
        <input type='file' className='ect-file-picker__input' multiple onChange={_handleFileChoose} id='fileButton' />
        <span className='ect-file-picker__hint'>(Pdf, Doc, Docx, Xls, Xlsx, Png, Jpg, Jpeg, Txt, Msg / Max. 25Mb)</span>
      </div>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/app/Components/FilePicker/UploadButton.jsx